document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".govie-iframe-wrapper-outer");

  wrappers.forEach(function (wrapper) {
    const iframe = wrapper.querySelector(".govie-iframe-wrapper");
    if (!iframe) return;

    let inactivityTimeout; // timer holder

    // disable by default
    iframe.style.pointerEvents = "none";

    // enable on wrapper click
    wrapper.addEventListener("click", function () {
      iframe.style.pointerEvents = "auto";

      // clear any old timer
      clearTimeout(inactivityTimeout);

      // start watching user activity
      window.addEventListener("scroll", resetInactivityTimer);
      window.addEventListener("mousemove", resetInactivityTimer);

      startInactivityTimer();
    });

    function startInactivityTimer() {
      inactivityTimeout = setTimeout(function () {
        iframe.style.pointerEvents = "none";

        // stop listening once disabled
        window.removeEventListener("scroll", resetInactivityTimer);
        window.removeEventListener("mousemove", resetInactivityTimer);
      }, 10000);
    }

    function resetInactivityTimer() {
      clearTimeout(inactivityTimeout);
      startInactivityTimer();
    }
  });
});
